import { render } from "./EstateAgencyPublicProfile.vue?vue&type=template&id=12147bd6&ts=true"
import script from "./EstateAgencyPublicProfile.vue?vue&type=script&lang=ts"
export * from "./EstateAgencyPublicProfile.vue?vue&type=script&lang=ts"

import exportComponent from "F:\\agent009\\_work\\569\\s\\sites\\easyestate\\easyestate.front\\ClientApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__